import { useState } from 'react';
import {
  Form,
  Button,
  PageHeader,
  Popconfirm,
} from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { useFetchData } from '../../../../hooks/useFetchData';
import { Spinner } from '../../../../components/Spinner';
import { Pages } from '../../../../1_shared/constants/pages';
import { apiService, notificationService, userService } from '../../../../services';
import { commonVerticalLayout } from '../../../../constants/formLayout';
import { CompletedWorkTabs } from '../../../../components/Tabs/CompletedWorkTabs';
import { Permissions } from '../../../../enums/permissions';

export const CompletedWorkEditPage = () => {
  const navigate = useNavigate();
  const param: any = useParams();
  const [form] = Form.useForm();

  const [isSaveBtnDisabled, setSaveBtnDisabled] = useState<boolean>(false);

  const { isLoading: isDataLoading, data = {} } = useFetchData(`/completed-works/${param.id}`);

  const isNew: boolean = !param.id;

  const subTitle: string = isNew
    ? 'Создание'
    : 'Редактирование';

  if (!isNew && isDataLoading) {
    return <Spinner />;
  }

  const handleCancel = () => {
    navigate(Pages.COMPLETED_WORKS);
  };

  const handleSave = async () => {
    try {
      setSaveBtnDisabled(true);

      await form.validateFields();
      const body = form.getFieldsValue();

      if (isNew) {
        const requestedData = await apiService.POST('/completed-works', body);

        navigate(`${Pages.COMPLETED_WORKS}/${requestedData.id}`);
      } else {
        await apiService.PATCH(`/completed-works/${data.id}`, body);
      }
      notificationService.notifySuccess('Успешно сохранено');
    } catch (error) {
      notificationService.notifyError(error);
    } finally {
      setSaveBtnDisabled(false);
    }
  };

  const handleDelete = async () => {
    try {
      setSaveBtnDisabled(true);
      await apiService.DELETE(`/completed-works/${data.id}`);
      navigate(Pages.COMPLETED_WORKS);
      notificationService.notifySuccess('Успешно удалено');
    } catch (error) {
      notificationService.notifyError(error);
    } finally {
      setSaveBtnDisabled(false);
    }
  };

  return (
    <>
      <PageHeader
        className="page-header"
        title="Выполненные работы"
        subTitle={subTitle}
        extra={[
          <Popconfirm
            key='delete-btn'
            title="Вы действительно хотите удалить?"
            onConfirm={handleDelete}
            disabled={isNew || !userService.hasAccess([Permissions.SUPER_ADMIN, Permissions.ADMIN])}
            okText="Да"
            cancelText="Нет"
          >
            <Button
              disabled={isNew || !userService.hasAccess([Permissions.SUPER_ADMIN, Permissions.ADMIN])}
              danger
            >
              Удалить
            </Button>
          </Popconfirm>,
          <Button key="2" onClick={handleCancel}>
            {isNew ? 'Отмена' : 'Закрыть'}
          </Button>,
          <Button
            key="1"
            type="primary"
            disabled={isSaveBtnDisabled || !userService.hasAccess([Permissions.SUPER_ADMIN, Permissions.ADMIN])}
            onClick={handleSave}
          >
            Сохранить
          </Button>,
        ]}
      />
      <div className='page-content'>
        <Form
          className="mg-t-16"
          form={form}
          labelAlign="left"
          requiredMark={false}
          initialValues={data}
          layout="vertical"
          {...commonVerticalLayout}
          disabled={!userService.hasAccess([Permissions.SUPER_ADMIN, Permissions.ADMIN])}
        >
          <CompletedWorkTabs generalTabProps={{ data, form }} />
        </Form>
      </div>
    </>
  );
};
